/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentitySettingsState
 */
export interface IdentitySettingsState {
    /**
     * 
     * @type {string}
     * @memberof IdentitySettingsState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentitySettingsState
     */
    disabled?: boolean;
}

export function IdentitySettingsStateFromJSON(json: any): IdentitySettingsState {
    return IdentitySettingsStateFromJSONTyped(json, false);
}

export function IdentitySettingsStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentitySettingsState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function IdentitySettingsStateToJSON(value?: IdentitySettingsState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


